"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowKeyFromRecordKey = void 0;
var get_value_by_path_key_1 = require("./get-value-by-path-key");
function getRowKeyFromRecordKey(recordKey) {
    var getRowKey = null;
    if (typeof recordKey === "function") {
        getRowKey = recordKey;
    }
    else if (typeof recordKey === "string") {
        getRowKey = function (record) {
            var value = get_value_by_path_key_1.getValueByPathKey(record, recordKey);
            return typeof value === "undefined" || value === null
                ? ""
                : String(value);
        };
    }
    else {
        // 如果未提供 rowKey，使用索引生成
        // TODO: 输出告警
        getRowKey = function (_, recordIndex) { return "record_" + recordIndex; };
    }
    return getRowKey;
}
exports.getRowKeyFromRecordKey = getRowKeyFromRecordKey;
//# sourceMappingURL=get-row-key-from-record-key.js.map